import { Button, Stack, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import type { TranslateFn } from '@newo/localization';
import type { FC } from 'react';

const VIBECREATOR_FALLBACK_BASE = 'https://vibecreator.newo.ai/vibe_creator';

const buildFallbackUrl = (description: string): string => {
	const url = new URL(VIBECREATOR_FALLBACK_BASE);
	url.searchParams.set('utm_source', 'newo');
	url.searchParams.set('utm_content', 'home_hero');
	url.searchParams.set('description', description);
	url.searchParams.set('conf', 'yes');
	return url.toString();
};

type CreatorChatFlowInactivityModalProps = {
	description: string;
	modalId: string;
	translate: TranslateFn;
};

const CreatorChatFlowInactivityModal: FC<
	CreatorChatFlowInactivityModalProps
> = ({ description, modalId, translate }) => {
	const handleContinueManual = () => {
		modals.close(modalId);
		globalThis.location.href = buildFallbackUrl(description);
	};

	return (
		<Stack
			align="center"
			className="w-[min(88vw,440px)] px-2 py-4"
			data-testid="creator-chat-flow-inactivity-modal"
			gap="md"
		>
			<Text ta="center">
				{translate('creator', 'businessConfirmation.inactivityModal.message')}
			</Text>
			<Button
				data-testid="creator-chat-flow-inactivity-continue-manual"
				fullWidth
				onClick={handleContinueManual}
			>
				{translate(
					'creator',
					'businessConfirmation.inactivityModal.continueButton'
				)}
			</Button>
		</Stack>
	);
};

export default CreatorChatFlowInactivityModal;
